"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _filters = require("./../utils/filters");

var _utils = require("./../../../helpers/utils"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _default = {
  name: 'sg-icon-grid',
  props: ['name'],
  data: function data() {
    return {
      icons: []
    };
  },
  filters: {
    sanitize: function sanitize(value) {
      if (!value.includes('icon')) return value;
      return (0, _filters.unbem)(value).replace('icon', '').trim();
    }
  },
  methods: {
    getRegisteredIcons: function getRegisteredIcons() {
      return this.$slots.register[0].children.map(function (child) {
        if (child.tag !== 'undefined' && child.tag === 'svg') {
          return {
            html: (0, _utils.getOuterHTML)(child.elm),
            title: child.data.staticClass.split(' ').pop()
          };
        }
      }).filter(Boolean);
    }
  },
  mounted: function mounted() {
    this.icons = this.getRegisteredIcons();
  }
};
exports["default"] = _default;